export class CdpClient {
    constructor(endpoint) {
        this.id = 0;
        this.pending = new Map();
        this.ws = new WebSocket(endpoint);
        this.wire();
    }
    /* public helpers ---------------------------------------------------------- */
    onOpen(cb) { this.ws.addEventListener('open', cb); }
    onEvent(name, cb) {
        this.ws.addEventListener('message', (e) => {
            const m = JSON.parse(e.data);
            if ('method' in m && m.method === name) {
                // console.debug(`[CDP EVENT] ${m.method}`, m.params);
                cb(m.params);
            }
        });
    }
    send(method, params = {}) {
        const id = ++this.id;
        const msg = { id, method, params };
        // Filter logs to avoid spam
        if (method === 'Input.dispatchKeyEvent') {
            console.debug(`[CDP KEY] ${method}`, params);
        }
        else if (method === 'Input.dispatchMouseEvent' && params.type !== 'mouseMoved') {
            console.debug(`[CDP MOUSE] ${method} (${params.type})`, params);
        }
        this.ws.send(JSON.stringify(msg));
        return new Promise((res, rej) => this.pending.set(id, (response) => {
            if (response.error) {
                if (method.startsWith('Input.')) {
                    console.error(`[CDP INPUT ERROR] ${method}`, response.error);
                }
                rej(response.error);
            }
            else {
                res(response.result);
            }
        }));
    }
    /* internal ---------------------------------------------------------------- */
    wire() {
        this.ws.addEventListener('message', (e) => {
            const m = JSON.parse(e.data);
            if ('id' in m && this.pending.has(m.id)) {
                this.pending.get(m.id)(m);
                this.pending.delete(m.id);
            }
        });
    }
    /* factory ----------------------------------------------------------------- */
    static connect(endpoint) { return new CdpClient(endpoint); }
}
